import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "lib/utils";
import { X } from "lucide-react";

const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    isShowBtnXClose?: boolean;
    btnCloseClassName?: string;
  }
>(({ className, align = "center", isShowBtnXClose, btnCloseClassName, sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      onInteractOutside={(event) => {
        if (isShowBtnXClose) {
          event.preventDefault();
        }
      }}
      className={cn(
        "relative z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none",
        "data-[state=open]:animate-in data-[state=closed]:animate-out",
        "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
        "data-[side=bottom]:slide-in-from-top-2",
        "data-[side=left]:slide-in-from-right-2",
        "data-[side=right]:slide-in-from-left-2",
        "data-[side=top]:slide-in-from-bottom-2",
        className
      )}
      {...props}
    >
      {isShowBtnXClose && (
        <PopoverPrimitive.Close
          aria-label="Close"
          className={`${
            isShowBtnXClose ? "bg-gray-200 dark:bg-accent dark:hover:bg-slate-900 rounded-full text-black dark:text-white hover:dark:text-white" : ""
          } absolute z-50 right-4 top-2 opacity-70 ring-offset-background transition-opacity hover:opacity-100 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground`}
        >
          <X className={cn(`w-[30px] h-[30px] rounded-full dark:bg-background dark:hover:bg-slate-900 p-1`, btnCloseClassName)} />
        </PopoverPrimitive.Close>
      )}

      {props.children}
    </PopoverPrimitive.Content>
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent };
